import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.734 14.411q.4-.293.826-.6C12.432 11.731 16 9.15 16 5.954 16 1.864 12 .5 8 .5S0 1.864 0 5.955c0 3.863 3.568 5.294 7.334 5.441V15.5c.405-.345.882-.708 1.4-1.089M11.33 6.7H4.666v-1.4h6.665z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BubbleRoundFilledSize16Glyph.displayName = 'BubbleRoundFilledSize16Glyph';
